module.exports = __webpack_public_path__ + "static/media/SPG_QR_app.847bdc58.svg";